var Backbone = require('backbone');
var _ = require('underscore');

require('./StyleTag.less');

module.exports = Backbone.View.extend({});
